import { PrimaryCredentialType } from "types/therapist.types";

export const PRIMARY_CREDENTIAL_TYPE: Record<PrimaryCredentialType, string> = {
  i_am_licensed: "Licensed therapist",
  i_am_pre_licensed: "Pre-licensed therapist",
  i_have_no_license: "Therapist with no license",
};
